/**
 * Opus Button - Floating action button to open the AI panel
 */

import { Bot, Sparkles } from 'lucide-react';
import { useOpusAIStore } from '@/stores/opus-ai-store';

export function OpusButton() {
  const { isOpen, togglePanel } = useOpusAIStore();

  if (isOpen) {
    return null;
  }

  return (
    <button
      onClick={togglePanel}
      className="
        fixed bottom-6 right-6 z-40
        w-14 h-14 rounded-full
        bg-emerald-500 hover:bg-emerald-600
        text-white shadow-lg
        flex items-center justify-center
        transition-all duration-200
        hover:scale-105 active:scale-95
        glow-on-hover
      "
      aria-label="Open Opus AI Assistant"
    >
      <div className="relative">
        <Bot className="w-6 h-6" />
        <Sparkles className="w-3 h-3 absolute -top-1 -right-1 text-emerald-200" />
      </div>
    </button>
  );
}
